function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var _ref = /*#__PURE__*/React.createElement("path", {
  d: "m135 362h-120c-8.402344 0-15 6.597656-15 15v120c0 8.398438 6.597656 15 15 15h120c8.402344 0 15-6.601562 15-15v-120c0-8.402344-6.597656-15-15-15zm0 0",
  fill: "#64e1dc"
});

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "m382.699219 91.199219c-6.601563-2.699219-14.101563-.601563-18.300781 5.398437l-45.597657 68.703125-49.300781-96.902343c-2.699219-5.097657-8.101562-7.800782-13.5-7.800782s-10.800781 2.703125-13.5 7.800782l-49.300781 96.902343-45.601563-68.703125c-4.199218-6-11.699218-8.097656-18.296875-5.398437-6.601562 2.699219-10.5 9.601562-9 16.800781l30 151c1.5 6.898438 7.5 12 14.699219 12h182c7.199219 0 13.199219-5.101562 14.699219-12l30-151c1.5-7.199219-2.398438-14.101562-9-16.800781zm0 0",
  fill: "#fdbf00"
});

var _ref3 = /*#__PURE__*/React.createElement("path", {
  d: "m391.699219 108-30 151c-1.5 6.898438-7.5 12-14.699219 12h-91v-210.402344c5.398438 0 10.800781 2.703125 13.5 7.800782l49.300781 96.902343 45.601563-68.703125c4.199218-6 11.699218-8.097656 18.296875-5.398437 6.601562 2.699219 10.5 9.601562 9 16.800781zm0 0",
  fill: "#ff9100"
});

var _ref4 = /*#__PURE__*/React.createElement("path", {
  d: "m317 301h-122c-8.402344 0-15 6.597656-15 15v181c0 8.398438 6.597656 15 15 15h122c8.402344 0 15-6.601562 15-15v-181c0-8.402344-6.597656-15-15-15zm0 0",
  fill: "#ffda2d"
});

var _ref5 = /*#__PURE__*/React.createElement("path", {
  d: "m497 422h-120c-8.402344 0-15 6.597656-15 15v60c0 8.398438 6.597656 15 15 15h120c8.402344 0 15-6.601562 15-15v-60c0-8.402344-6.597656-15-15-15zm0 0",
  fill: "#ff637b"
});

var _ref6 = /*#__PURE__*/React.createElement("path", {
  d: "m332 316v181c0 8.398438-6.597656 15-15 15h-61v-211h61c8.402344 0 15 6.597656 15 15zm0 0",
  fill: "#fdbf00"
});

var _ref7 = /*#__PURE__*/React.createElement("path", {
  d: "m256 0c-24.902344 0-46 20.097656-46 45 0 24.898438 21.097656 45 46 45s46-20.101562 46-45c0-24.902344-21.097656-45-46-45zm0 0",
  fill: "#ffda2d"
});

var _ref8 = /*#__PURE__*/React.createElement("path", {
  d: "m135 120c-24.8125 0-45-20.1875-45-45s20.1875-45 45-45 45 20.1875 45 45-20.1875 45-45 45zm0 0",
  fill: "#ffda2d"
});

var _ref9 = /*#__PURE__*/React.createElement("path", {
  d: "m377 120c-24.8125 0-45-20.1875-45-45s20.1875-45 45-45 45 20.1875 45 45-20.1875 45-45 45zm0 0",
  fill: "#fdbf00"
});

var _ref10 = /*#__PURE__*/React.createElement("path", {
  d: "m256 90v-90c24.902344 0 46 20.097656 46 45 0 24.898438-21.097656 45-46 45zm0 0",
  fill: "#fdbf00"
});

var _ref11 = /*#__PURE__*/React.createElement("path", {
  d: "m150 377v120c0 8.398438-6.597656 15-15 15h-60v-150h60c8.402344 0 15 6.597656 15 15zm0 0",
  fill: "#00c8c8"
});

var _ref12 = /*#__PURE__*/React.createElement("path", {
  d: "m512 437v60c0 8.398438-6.597656 15-15 15h-60v-90h60c8.402344 0 15 6.597656 15 15zm0 0",
  fill: "#e63950"
});

function SvgPodium({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    height: "512pt",
    viewBox: "0 0 512 512",
    width: "512pt",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref, _ref2, _ref3, _ref4, _ref5, _ref6, _ref7, _ref8, _ref9, _ref10, _ref11, _ref12);
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPodium);
export default __webpack_public_path__ + "static/media/podium.d6bf5a50a532d0343c47e7ce70406e43.svg";
export { ForwardRef as ReactComponent };